import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EntidadAuditoraService } from './entidadauditora.service';
import { RegCampaniaEntidadAuditoraViewModel } from './entidadauditora.types';
import { DatePipe } from '@angular/common';
import { OnInit } from '@angular/core';
import { Tc } from '../../../core/_infrastructure/types/common';

@Component({
    selector: 'app-campaniaentidad-edit',
    templateUrl: './campaniaentidad-edit.component.html',
})
export class CampaniaEntidadEditComponent extends ComponentBase implements OnInit {
    /** nombrescientificos-edit ctor */

    editMode: boolean;
    editTitle = 'Nueva';
    listCampanias: Tc[];
    campania: RegCampaniaEntidadAuditoraViewModel;
    visibilitySpinner = false;
    isCollapsedEntidad = false;
    IdEntidadAuditora: number;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        private entidadAuditoraService: EntidadAuditoraService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.campania = new RegCampaniaEntidadAuditoraViewModel();
    }

    ngOnInit() {
        this.globalService.getAllCampanias().subscribe(res => {
            this.listCampanias = res;
        });

        this.createForm();

        let idEntidad = +this.activatedRoute.snapshot.params['id'];
        let idCampania = +this.activatedRoute.snapshot.params['idCampania'];

        this.IdEntidadAuditora = idEntidad;

        //EDIT
        if (idCampania) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.entidadAuditoraService.getCampania(idEntidad, idCampania).subscribe(result => {
                this.campania = result;
                this.updateForm();
            });
        }
        //ALTA
        else {
            //En el alta se graba activa por defecto
            this.form.controls['Activa'].disable();
        }
    }

    createForm() {
        this.form = this.fb.group({
            IdCampania: [null, Validators.required],
            IdRegEntidadAuditora: null,
            Activa: true,
            FechaAlta: [{ value: '', disabled: true }],
            FechaBaja: [{ value: '', disabled: true }],
        });
    }

    updateForm() {
        this.form.setValue({
            IdCampania: this.campania.IdCampania,
            IdRegEntidadAuditora: this.campania.IdRegEntidadAuditora,
            Activa: this.campania.Activa,
            FechaAlta: new Date(this.campania.FechaAlta),
            FechaBaja: this.campania.FechaBaja != null ? new Date(this.campania.FechaBaja) : '',
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            this.isCollapsedEntidad = false;
            return;
        }

        this.visibilitySpinner = true;

        let campania = new RegCampaniaEntidadAuditoraViewModel();

        campania.IdCampania = this.form.value.IdCampania;
        campania.IdRegEntidadAuditora = this.IdEntidadAuditora;
        campania.Activa = this.form.value.Activa; //Solo lleva valor en el EDIT, en el insert se guarda como Activa en el service

        if (this.editMode) {
            this.entidadAuditoraService.editCampania(campania).subscribe({
                next: () => {
                    this.addSuccessMessage('Campaña autorizada modificada correctamente');
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                },
            });
        } else {
            this.entidadAuditoraService.addCampania(campania).subscribe({
                next: () => {
                    this.addSuccessMessage('Campaña autorizada añadida correctamente');
                    this.visibilitySpinner = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/registros/entidadesauditoras/edit', this.IdEntidadAuditora]);
    }
}
